import ReactSelect, { createFilter } from "react-select";
import CustomOption from "./CustomOption";
import CustomMenuList from "./CustomMenuList";
import useSettings from "../../../hooks/useSettings";
import useTranslate from "../../../hooks/useTranslate";
import { colourStyles } from "../../../utils/reactSelectConfig";
import styles from "../../../styles/Select.module.css";

interface FlightLocationInputProps {
  optionsData: any;
  label: string;
  placeholder: string;
  id: string;
  onChange: (val: string) => void;
  selectedItem: any;
}

const FlightLocationInput: React.FC<FlightLocationInputProps> = ({
  optionsData,
  label,
  placeholder,
  id,
  onChange,
  selectedItem,
}) => {
  const { language } = useSettings();
  const { translatedText } = useTranslate(placeholder || '', language);

  const renderAirportsData = () =>
    optionsData?.map((el: { port: string, code: string }) => {
      const value = el ? `${el?.code} - ${el?.port}` : "";
      return { value: el?.code, label: value };
    });

  const findOptionToDisplay = (code: string) => {
    const option = code ? optionsData?.find((el: { port: string, code: string }) => el?.code === code) : "";
    return { value: option?.code, label: `${option?.code} - ${option?.port}` };
  };

  const airportsData = renderAirportsData();

  return (
    <>
    {airportsData?.length > 0 && (
    <div className={`${styles.customSelect} delayed-fadein`} style={{ zIndex: 999 }}>
    {label && <label className={`${styles.inputLabel} translate-dynamic`} htmlFor={id}>{label || ''}</label>}
    <div className="no-translate">
      <ReactSelect
        inputId={id}
        captureMenuScroll={false}
        components={{
          Option: CustomOption,
          MenuList: CustomMenuList as any,
          IndicatorSeparator:() => null
        }}
        classNames={{
          option: () => 'no-translate',
          singleValue: () => 'no-translate',
        }}
        filterOption={createFilter({ ignoreAccents: false })}
        options={airportsData}
        classNamePrefix="custom-react-select"
        placeholder={translatedText}
        onChange={value => onChange(value?.value)}
        value={(selectedItem && findOptionToDisplay(selectedItem)) || ''}
        styles={colourStyles}
        menuPortalTarget={document.body}
        theme={(theme) => ({
          ...theme,
          borderRadius: 6,
          padding: 0,
          colors: {
            ...theme.colors,
            primary: 'var(--fow-gray-light-color)',
          },
        })}
      />
    </div>
    </div>
    )}
    </>
  );
};

export default FlightLocationInput;
